export const getInitialsFromUsername = (username?: string): string => {
	if (!username) return '';
	const names = username.split(' ');
	if (names.length === 0) return '';
	if (names.length === 1) return names[0].charAt(0).toUpperCase();
	return `${names[0].charAt(0).toUpperCase()}${names[names.length - 1].charAt(0).toUpperCase()}`;
};
